export default __webpack_public_path__ + "static/media/add.114cc462.svg";